import { fetcher } from '@commenda/utils';
import { BASE_URL } from './helpers';

export const publishWorkflowTemplateVersion = async (
  workflowTemplateVersionId: string
): Promise<Response> => {
  const res = await fetcher(
    `${BASE_URL}/version/${workflowTemplateVersionId}/publish`,
    {
      method: 'POST',
    }
  );
  return res;
};
